import React, { useState, useEffect, useMemo, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Form, Button, Table, Empty } from '@whalecloud/fdx';
import CommonModal from '@/components/CommonModal';

import { renderFormItems } from '@/utils';

import { subsAttrs, isdnSearchFormItems } from './utils';

import styles from './index.module.less';

const SubscriberAttributes = props => {
  const {
    modelKey, addressId, form: { getFieldDecorator, getFieldValue, validateFields, setFieldsValue }, refInstance,
    offerDetail = {}, offerAccessType, attrObj, packageIdList,
    dispatch,
  } = props;
  const [isdnMaxE1Cnt, setISDNMaxE1Cnt] = useState(0);
  const [isdnMaxDidCnt, setISDNMaxDidCnt] = useState(6000);
  const [isdnNbrList, setISDNNbrList] = useState();
  const [visible, setVisible] = useState(false);
  const [initialEnd, setInitialEnd] = useState(false);

  useImperativeHandle(refInstance, () => ({
    getAttributeInfo: async exchangedInfo => {
      const result = await validateFields();
      const attrs = { ...(result || {}), ...exchangedInfo };
      const subsAttrList = [];
      let isdnAttrObj = {};
      Object.keys(attrs).forEach(key => {
        if (attrs[key] && !key.includes('empty')) {
          if (['EXP_DID_CNT', 'EXP_ISDN_E1_CNT'].includes(key)) {
            isdnAttrObj = {
              EXP_DID_CNT: attrs.EXP_DID_CNT,
              EXP_ISDN_E1_CNT: attrs.EXP_ISDN_E1_CNT,
            };
          } else {
            subsAttrList.push({
              attrCode: key,
              value: attrs[key],
              attrValue: attrs[key],
            });
          }
        }
      });
      return {
        subsAttrList,
        isdnAttrObj,
      };
    },
  }));

  const initial = async () => {
    const offerAttrList = get(offerDetail, 'subsPlanDto.attrDtoList') || [];
    const maxCountObj = offerAttrList.find(it => it.attrCode === 'EXP_ISDN_MAX_E1_CNT') || {};
    setISDNMaxE1Cnt(maxCountObj.defaultValue);
    const maxDidObj = offerAttrList.find(it => it.attrCode === 'ISDN_MAX_DID_CNT') || {};
    if (maxDidObj.defaultValue) {
      setISDNMaxDidCnt(maxDidObj.defaultValue);
    }
    // 查询宽带带宽 qryPackageIdInfo
    if (`${get(offerDetail, 'indepProdSpecDto.servType') || ''}` === '79') {
      await dispatch({
        type: 'business/qryPackageIdInfo',
        payload: {
          subsPlanId: get(offerDetail, 'subsPlanDto.subsPlanId'),
          addressId,
        },
        modelKey,
      });
    }
    setInitialEnd(true);
  };

  useEffect(() => {
    if (!isEmpty(offerDetail)) {
      initial();
    }
  }, [offerDetail, offerAccessType]);

  const isdnMainNbrSearch = () => {
    const value = getFieldValue('isdnMainNbr');
    dispatch({
      type: 'business/qryEpbxIsdnNbrList', // 查询ISDN主号码列表
      payload: {
        isdnNbr: value,
        indepProdId: get(offerDetail, 'indepProdSpecDto.indepProdSpecId'),
        // isdnNbr: '832-200654',
        // indepProdId: 200006,
      },
      modelName: modelKey,
    }).then(res => setISDNNbrList(res));
  };

  const handleRowClick = record => {
    setFieldsValue({ BSNL_ISDN_MAIN_NUM: record.isdnNbr });
    setVisible(false);
  };

  const validatorMax = (rule, value, callback, otherName) => {
    const otherValue = getFieldValue(otherName) || 0;
    const result = value + otherValue;
    //  当EXP_ACCESS_TYPE = BRI 时，
    // 0 <= EXP_ISDN_INCOMMING_CHANNEL + EXP_ISDN_OUTGOING_CHANNEL <=2；
    // 当EXP_ACCESS_TYPE = PRI 时，
    // 0 <= EXP_ISDN_INCOMMING_CHANNEL + EXP_ISDN_OUTGOING_CHANNEL <=EXP_ISDN_E1_CNT值*30；
    if (offerAccessType === 'BRI' && result > 2) {
      return callback('error!');
    }
    const e1Count = getFieldValue('EXP_ISDN_E1_CNT') || 0;
    if (offerAccessType === 'PRI' && result > (e1Count * 30)) {
      return callback('error!');
    }
    return callback();
  };

  const isdnTableColumns = [
    {
      title: i18n('MAIN_NUMBER'),
      dataIndex: 'isdnNbr',
      key: 'isdnNbr',
    },
    {
      title: i18n('ORDER_CUSTOMER_NAME'),
      dataIndex: 'custName',
      key: 'custName',
    },
    {
      title: i18n('SSA_CODE'),
      dataIndex: 'ssaCode',
      key: 'ssaCode',
    },
    {
      title: i18n('SSA_NAME'),
      dataIndex: 'ssaName',
      key: 'ssaName',
    },
    {
      title: i18n('FR_CODE'),
      dataIndex: 'frCode',
      key: 'orderCode',
    },
  ];

  const subsAttrItems = useMemo(() => subsAttrs({
    modelKey,
    attrObj,
    isdnMaxE1Cnt,
    isdnMaxDidCnt,
    accessType: (offerAccessType || '').toUpperCase(),
    serviceType: `${get(offerDetail, 'indepProdSpecDto.servType') || ''}`,
    isdnNumberList: isdnNbrList,
    packageIdList,
    getMax: validatorMax,
    onISDNClick: () => setVisible(true),
  }), [offerAccessType, attrObj, isdnNbrList, isdnMaxE1Cnt, offerDetail, packageIdList]);

  return (
    <>
      {
        initialEnd && (
          <Form layout="inline">
            <div className="blockWrap">
              <h3 className="blockTitle">{i18n('SUBS_ATTR')}</h3>
              <div className="formItemBox">
                {subsAttrItems.length > 0 ? renderFormItems(subsAttrItems, getFieldDecorator) : (
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Empty description={i18n('BUSINESS_NO_MORE_ATTRS')} />
                  </div>
                )}
              </div>
            </div>
          </Form>
        )
      }
      {visible && (
        <CommonModal
          modalOpts={{
            title: i18n('SELECT_ISDN_MAIN_NBR'),
            footer: null,
            draggable: false,
            onCancel: () => setVisible(false),
            width: 800,
          }}
        >
          <div>
            <Form layout="inline" style={{ position: 'relative' }}>
              {renderFormItems(isdnSearchFormItems, getFieldDecorator)}
              <div className={styles.searchFooter}>
                <Button type="primary" onClick={isdnMainNbrSearch}>{i18n('BTN_QUERY')}</Button>
                {/* <Button onClick={handleFormRest}>{i18n('BTN_RESET')}</Button> */}
              </div>
            </Form>
            <Table
              rowKey="isdnNbr"
              dataSource={isdnNbrList}
              columns={isdnTableColumns}
              onRow={record => ({
                onClick: () => handleRowClick(record),
              })}
            />
          </div>
        </CommonModal>)}
    </>
  );
};

const Component = connect((state, { modelKey }) => ({
  attrObj: state[modelKey].attrObj || {},
  offerAccessType: state[modelKey].offerAccessType,
  packageIdList: state[modelKey].packageIdList || [],
}))(Form.create()(SubscriberAttributes));
export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
